import styled from 'styled-components';

export const LiveCasinoFilterButtonsDefaultBox = styled.div`
  white-space: nowrap;

  overflow-x: auto;
  overflow-y: hidden;

  overflow: -moz-scrollbars-none;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;

  &::-webkit-scrollbar {
    display: none;
  }

  z-index: 5;
  padding: 0 4rem;

  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    width:100%;
    margin: 0;
    padding: 0 1rem;
  }
`;